import React from 'react';
import { ICheckBoxesProps } from './checkBoxes.types';

export const CheckBoxes = (props : ICheckBoxesProps) => {

    const { setSelectedFilter, filter,  value  } = props;

    const handleChange = (e : any) => {
        setSelectedFilter(e.target.value)
      }

  return (
    <div className= {value.id === filter?"chkt action":"chk action"}>
    <label >
      <input  type="radio" name="filter" defaultChecked={value.id === filter?true:false}  value={value.id} onChange={handleChange} />
       <span>{value.name}</span>
    </label>
   </div>
  )
}